export function OscarRequestInvoiceCtrl ($uibModalInstance, $scope, OscarInvoices, messages, invoice) {
  $scope.invoice = invoice;

  $scope.OscarInvoices = new OscarInvoices();

  $scope.continue = function () {
    $scope.OscarInvoices.getOscarItems($scope.invoice).then(data => {
      $uibModalInstance.close(data);
    }).catch(err => {
      messages.error(err);
    });
  };

  $scope.overwrite = function () {
    $scope.OscarInvoices.overwrite($scope.invoice).then(data => {
      $uibModalInstance.close(data);
    }).catch(err => {
      $uibModalInstance.dismiss();
    });
  };
}